import { createContext } from 'react';
export const MaydayMessageContext = createContext(null);
